export enum SpeachState{
  NON_PUBLIE='NON_PUBLIE',
  PUBLIE="PUBLIE",
  ARCHIVE="ARCHIVE"
}
